module.exports = __webpack_public_path__ + "img/internet-dark.f0b696e1.svg";